import React, { useState } from 'react';
import axios from 'axios';
import './ForgotPassword.css';
import Navbar from "../components/navbar";
import Footer from "../components/Footer";

const PasswordResetRequest = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      /*await axios.post('/api/request-password-reset/', { email });*/
      await axios.post('/api/request-password-reset/', { email });
      setStatus('success');
    } catch (err) {
      setStatus('error');
    }
  };

 return (
  <>
    <Navbar />
    <div className="login-page">
      <div className="login-card">
        <h2 className="login-heading">Request Password Reset</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            className="input-field"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
        {status === 'success' && (
          <p className="success-msg">Request submitted successfully.</p>
        )}
        {status === 'error' && (
          <p className="error-msg">There was an error submitting the request.</p>
        )}
      </div>
    </div>
    <Footer />
    </>
  );
};


export default PasswordResetRequest;